import * as React from "react";

import { Model } from "@flowable/forms";

import { CodeValidationContextWrapper } from "components/flowable/ClassificationCodes/internal/CodeValidationContext";

import { getComponentForCodeType } from "./types";


class ClassificationCodes extends Model.StatefulFormComponent {
	async componentDidMount () {
	}

	componentDidUpdate (prevProps, prevState, snapshot) {
	}

	shouldComponentUpdate (nextProps, nextState) {
		return this.props.config.value !== nextProps.config.value || this.props.config.$computedPath !== nextProps.config.$computedPath;
	}

	onChangeValue = value => {
		this.dispatchFocusEvent();
		this.props.onChange(value);
	}

	render () {
		const {
			Components,
			config: {
				id,
				enabled,
				label,
				isRequired,
				value,
				extraSettings: {
					codeType,
					...rest
				},
				customValidations = []
			},
		} = this.props;

		const initialValue = [ { code: "", percentage: "" } ];
		const disabled = enabled === false;
		const bem = this.bem("panel", { disabled });
		const Component = getComponentForCodeType(codeType);

		return  (
			<div className={bem()}>
				<CodeValidationContextWrapper
					codes={value || initialValue}
					isRequired={isRequired}
					includePercentage={rest.includePercentage}
					customValidations={customValidations}
				>
					<Component
						{...rest}
						id={id}
						value={value}
						onChange={this.onChangeValue}
						enabled={enabled}
						label={label}
						isRequired={isRequired}
						onFocus={this.dispatchFocusEvent}
					/>
				</CodeValidationContextWrapper>
				<Components.description {...this.props}/>
			</div>
		);
	}
}

export default ClassificationCodes;
